import React from 'react';
import { Link } from 'react-router-dom';
import { Building2, Clock, CheckCircle, Mail, FileText } from 'lucide-react';

const RegistrationPending: React.FC = () => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-blue-50 via-white to-purple-50 py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8">
        <div className="text-center">
          <div className="flex items-center justify-center">
            <div className="flex items-center space-x-2">
              <Building2 className="w-10 h-10 text-blue-600" />
              <span className="text-2xl font-bold text-gray-900">AetherFlow</span>
            </div>
          </div>
          
          <div className="mt-8">
            <div className="w-16 h-16 bg-yellow-100 rounded-full flex items-center justify-center mx-auto">
              <Clock className="w-8 h-8 text-yellow-600" />
            </div>
            
            <h2 className="mt-6 text-2xl font-bold text-gray-900">
              Registration Under Review
            </h2>
            
            <p className="mt-2 text-gray-600">
              Thank you for registering as a developer! Your application is currently being reviewed by our admin team.
            </p>
          </div>
          
          <div className="mt-8 bg-blue-50 rounded-lg p-6">
            <h3 className="text-lg font-semibold text-blue-900 mb-4">What happens next?</h3>
            <div className="space-y-4 text-left">
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-0.5">
                  <span className="text-blue-600 text-sm font-semibold">1</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-blue-900">Document Review</p>
                  <p className="text-sm text-blue-700">Our team will review your education, certifications, and uploaded documents.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-0.5">
                  <span className="text-blue-600 text-sm font-semibold">2</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-blue-900">Skills Verification</p>
                  <p className="text-sm text-blue-700">We'll verify your technical skills and experience level.</p>
                </div>
              </div>
              
              <div className="flex items-start space-x-3">
                <div className="w-6 h-6 bg-blue-100 rounded-full flex items-center justify-center mt-0.5">
                  <span className="text-blue-600 text-sm font-semibold">3</span>
                </div>
                <div>
                  <p className="text-sm font-medium text-blue-900">Approval Notification</p>
                  <p className="text-sm text-blue-700">You'll receive an email and notification once approved.</p>
                </div>
              </div>
            </div>
          </div>

          <div className="mt-8 space-y-4">
            <div className="flex items-center justify-center space-x-2 text-sm text-gray-600">
              <Mail className="w-4 h-4" />
              <span>We'll notify you via email when your account is approved</span>
            </div>
            
            <div className="flex items-center justify-center space-x-2 text-sm text-gray-600">
              <FileText className="w-4 h-4" />
              <span>Review typically takes 1-3 business days</span>
            </div>
          </div>

          <div className="mt-8 space-y-4">
            <Link
              to="/"
              className="block w-full px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors duration-200 text-center"
            >
              Return to Homepage
            </Link>
            
            <Link
              to="/login"
              className="block w-full px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition-colors duration-200 text-center"
            >
              Sign In
            </Link>
          </div>

          <div className="mt-8 text-center">
            <p className="text-sm text-gray-500">
              Questions about your application?{' '}
              <a href="mailto:support@aetherflow.com" className="text-blue-600 hover:text-blue-500">
                Contact Support
              </a>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RegistrationPending;